import React, { useState } from 'react';
import axios from 'axios';
import {
  Alert,
  Box,
  Button,
  Container,
  Paper,
  TextField,
  Typography
} from '@mui/material';
import { MailOutline } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setIsSubmitting(true);
    setSuccessMessage('');
    setErrorMessage('');

    try {
      const response = await axios.post('/users/forgot-password', { email });
      setSuccessMessage(response.data?.message || 'If the email exists, a reset link has been sent.');
      setEmail('');
    } catch (error: any) {
      setErrorMessage(error.response?.data?.message || 'Unable to send reset email right now.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ py: 8 }}>
      <Paper sx={{ p: 4 }}>
        <Box sx={{ textAlign: 'center', mb: 3 }}>
          <MailOutline sx={{ fontSize: 46, color: 'primary.main', mb: 1 }} />
          <Typography variant="h4" gutterBottom>
            Forgot Password
          </Typography>
          <Typography color="text.secondary">
            Enter your registered email and we will send you a reset link.
          </Typography>
        </Box>

        {successMessage && <Alert severity="success" sx={{ mb: 2 }}>{successMessage}</Alert>}
        {errorMessage && <Alert severity="error" sx={{ mb: 2 }}>{errorMessage}</Alert>}

        <Box component="form" onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label="Registered Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            margin="normal"
            required
          />

          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 2 }}
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Sending...' : 'Send Reset Link'}
          </Button>

          <Typography align="center" sx={{ mt: 2 }}>
            <RouterLink to="/login">Back to Login</RouterLink>
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default ForgotPassword;
